/// <reference path="../../../typings/tsd.d.ts" /> 
import Services = warsApp.services;

module warsApp.directives {
    export interface IBaseFieldSectionScope extends ng.IScope {
        formSection: warsApp.models.FormSection;
        form: Wars.Domain.Model.Form;
        processConfigurationId: string;
        formData: any;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        formId: string;
        formDataId: string;
        isConfigureMode: boolean;
        isEditMode: boolean;
        showSlider: boolean;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration
    }

    export abstract class FieldBaseModel {
        constructor(protected $scope: IBaseFieldSectionScope,
            protected modalService: any,
            protected formSectionService: Services.FormSectionService,
            protected formService: Services.FormService,
            protected deleteService: services.DeleteService) { }

        public deleteField(field: Wars.Domain.Model.Field) {
            this.deleteService.deleteWithModalConfirmIfNecessary("Field",
                field.id,
                "Field",
                () => {
                    for (var i = 0; i < this.$scope.formSection.fields.length; i++) {
                        if (field.position < this.$scope.formSection.fields[i].position) {
                            this.$scope.formSection.fields[i].position -= 1;
                        }
                    }

                    this.formSectionService.splitFields(<any>this.$scope.formSection);
                    this.formService.setupFormSchema(this.$scope.form);
                    this.formService.saveAllChanges();
                });
        }

        public editField(field: Wars.Domain.Model.Field) {
            this.formService.editField(field,
                this.$scope.formSection,
                this.$scope.processConfiguration,
                this.$scope.form);
        }
    }
}